var map = {
	"./ai.png": "2832",
	"./bigdata.png": "f25b",
	"./line_wizai.png": "7697",
	"./project_ai.png": "6811",
	"./project_dev.png": "2c2c",
	"./project_system.png": "6cf3",
	"./project_weather.png": "75bb",
	"./system.png": "57a8",
	"./title_community.png": "f76f",
	"./title_project.png": "7bff",
	"./title_technology.png": "5189",
	"./title_vision.png": "2920",
	"./title_wizai.png": "6b39",
	"./weather.png": "9921",
	"./wfms.png": "d9bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c7d";